import { useModal } from 'providers/modalProvider';
import MODAL_COMPONENT from './ModalsComponents';

const Modal = () => {
  const { modalState } = useModal();
  return MODAL_COMPONENT[modalState?.type] || false;
};

export default Modal;
